'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rightArrow = require('./rightArrow.js');

var _rightArrow2 = _interopRequireDefault(_rightArrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenProviderLicense = function (_React$Component) {
  (0, _inherits3.default)(FullscreenProviderLicense, _React$Component);

  function FullscreenProviderLicense(props) {
    (0, _classCallCheck3.default)(this, FullscreenProviderLicense);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenProviderLicense.__proto__ || (0, _getPrototypeOf2.default)(FullscreenProviderLicense)).call(this, props));

    _this.state = {
      selected: null
    };
    return _this;
  }

  (0, _createClass3.default)(FullscreenProviderLicense, [{
    key: 'onProviderLoaded',
    value: function onProviderLoaded(loadedData) {
      this.setState(loadedData);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selected = null;
      if (this.state.selected) {
        selected = this.state.selected;
      } else if (this.props.pricingData) {
        selected = this.props.pricingData.selected;
      }
      return selected ? _react2.default.createElement(
        'div',
        {
          className: 'pro-fullscreen-selected-license',
          onClick: function onClick() {
            _this2.props.actions.toggleMobileShopFrame();
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'pro-fullscreen-license-price' },
          selected.price
        ),
        _react2.default.createElement(_rightArrow2.default, { className: 'pro-fullscreen-show-shop-frame' }),
        _react2.default.createElement(
          'div',
          { className: 'pro-fullscreen-license-title' },
          selected.title
        )
      ) : null;
    }
  }]);
  return FullscreenProviderLicense;
}(_react2.default.Component);

exports.default = FullscreenProviderLicense;